export const analytics = {
    gtmId: process.env.REACT_APP_GIFTLY_GTM_ID,
    abTestingExperimentId: process.env.REACT_APP_AB_TESTING_EXPERIMENT_ID
};
